import React, {Component} from 'react';
import {Button} from "reactstrap";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {Spinner} from "../../Spinner";
import {CredentialRow} from "./CredentialRow";
import {AddCredentialModal} from "./AddCredentialModal";
import {
    GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL, ANALYTICS_CHANNEL
} from "../../channels/channels";
import { withTranslation } from 'react-i18next';


const CHANNEL_DISPLAY_NAMES = {
    [GOOGLE_CHANNEL]: 'Google Ads',
    [FACEBOOK_CHANNEL]: 'Meta Ads',
    [TIKTOK_CHANNEL]: 'TikTok Ads',
    [LINKEDIN_CHANNEL]: 'LinkedIn Ads',
    [ANALYTICS_CHANNEL]: 'GA4',
};

class ChannelCredentialsListClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaving: false,
        };
        this.handleCredentialRemoved = this.handleCredentialRemoved.bind(this);
    }

    handleCredentialRemoved(credentialId) {
        this.props.onCredentialRemoved(this.props.channel, credentialId);
    }

    renderCredentialsTable() {
        const { credentials, t } = this.props;

        if (!credentials || credentials.length === 0) {
            return null;
        }

        return (
            <div className="table-box">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('channel_credentials_list.label')}</th>
                        <th>{t('channel_credentials_list.ad_accounts')}</th>
                        <th>{t('channel_credentials_list.connected_since')}</th>
                        <th>{t('channel_credentials_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {credentials.map((cred) =>
                        <CredentialRow key={cred.id}
                                       credential={cred}
                                       onRemove={this.handleCredentialRemoved}
                                       isSaving={this.state.isSaving}
                        />
                    )}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { channel, credentials, t } = this.props;
        const displayName = CHANNEL_DISPLAY_NAMES[channel] || channel;
        const wrapperClassName = `section-body-item -wider box${this.props.wrapperClassName ? ` ${this.props.wrapperClassName}` : ''}`;
        const actionButtonClassName = this.props.actionButtonClassName || '-alt';
        const newConnectionLabel = this.props.newConnectionLabel || t('channel_credentials_list.new_connection');
        const title = this.props.titleOverride || displayName;

        if (credentials === null || credentials === undefined) {
            return (
                <div className={wrapperClassName}>
                    <div className="box-loader">
                        <Spinner color="positive"/>
                    </div>
                </div>
            );
        }

        return (
            <div className={wrapperClassName}>
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo channel={channel}/> {title}</h2>
                    <div className="float-right">
                        <Button className={actionButtonClassName} onClick={(e) => {e.stopPropagation(); this.addCredentialModal.toggle()}}>
                            {newConnectionLabel}
                        </Button>
                        <AddCredentialModal
                            ref={instance => { this.addCredentialModal = instance; }}
                            channel={channel}
                        />
                    </div>
                </header>
                {this.renderCredentialsTable()}
            </div>
        );
    }
}

export const ChannelCredentialsList = withTranslation()(ChannelCredentialsListClass);
export default ChannelCredentialsList;
